import { render, staticRenderFns } from "./ListDivisoes.vue?vue&type=template&id=54173fbe&scoped=true"
import script from "./ListDivisoes.vue?vue&type=script&lang=js"
export * from "./ListDivisoes.vue?vue&type=script&lang=js"
import style0 from "./ListDivisoes.vue?vue&type=style&index=0&id=54173fbe&prod&lang=scss"
import style1 from "./ListDivisoes.vue?vue&type=style&index=1&id=54173fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54173fbe",
  null
  
)

export default component.exports